import styled from 'styled-components';

const ParagraphCreated = styled.p`
  color: var(--on-background-grey);
  font-size: 16px;
  margin: 4px 0;
  display: flex;
  align-items: center;
`;

export default ParagraphCreated;
